import StatCard from "../../common/StatCard";
import { formatCurrency } from "../../../utils/formatters";
import {
  Wallet,
  TrendingUp,
  TrendingDown,
  CircleDollarSign,
} from "lucide-react";

const WalletStatCards = ({ data }) => {
  const stats = [
    {
      icon: <Wallet size={16} className="text-primary" />,
      label: "Current Balance",
      value: formatCurrency(data.currentBalance),
      accent: "bg-primary/10",
    },
    {
      icon: <TrendingUp size={16} className="text-green-400" />,
      label: "Total Credits",
      value: formatCurrency(data.totalCredits),
      sub: "Ingroove fees received",
      accent: "bg-green-400/10",
    },
    {
      icon: <TrendingDown size={16} className="text-red-400" />,
      label: "Total Debits",
      value: formatCurrency(data.totalDebits),
      sub: "Platform payouts processed",
      accent: "bg-red-400/10",
    },
    {
      icon: <CircleDollarSign size={16} className="text-amber-400" />,
      label: "Net Position",
      value: formatCurrency(data.totalCredits - data.totalDebits),
      sub: "Credits minus debits",
      accent: "bg-amber-400/10",
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {stats.map((s) => (
        <StatCard key={s.label} {...s} />
      ))}
    </div>
  );
};

export default WalletStatCards;
